import React, { useState, useEffect, useRef } from "react";
import {
  Link,
  Switch,
  Route,
  NavLink,
  BrowserRouter,
  useHistory,
} from "react-router-dom";
// import GovtInitiative from './container/GovtInitiative/GovtInitiative';
// import Central from './container/GovtInitiative/Central';
// import SMEGovt from './container/GovtInitiative/SMEGovt';
//import Header from './component/Common/Header';

// import Page404 from './component/Common/404';
import Login from "./component/Auth/Login";
import Signup from "./component/Auth/Signup";
import RegisterUniversity from './component/Auth/RegisterUniversity'
import Maindashboard from "./component/Dashboard/MainDashboard";

import Page404 from "./component/Pages/Page404";
import Page401 from "./component/Pages/Page401";
import Page500 from "./component/Pages/Page500";

import Protected from "./Protected";
import Unprotected from "./Unprotected";
import LeftSidebar from "./component/Common/LeftSidebar";

import Footer from "./component/Common/Footer";

import { useSelector } from "react-redux";
import { selectuser } from "./features/userSlice";

import UniversityList from "./component/University/List";
import UniversityAdd from "./component/University/Add";

import InstitutionList from "./component/Institution/List";
import InstitutionAdd from "./component/Institution/Add";
import LinkingUniversity from "./component/Institution/LinkingUniversity";
import EmployerList from "./component/Employer/List";
import EmployerAdd from "./component/Employer/Add";

import RecruiterList from "./component/Recruiter/List";
import RecruiterAdd from "./component/Recruiter/Add";
import RecruiterLinkingUniversity from "./component/Recruiter/LinkingUniversity";

import config from "./config";
import TopBar from "./component/Common/TopBar";
import { AddJob } from "./component/Jobs/AddJob";
import ListJob from "./component/Jobs/ListJob";

import ModalPopup from "./component/Common/ModalPopup";
import JobDetail from "./component/Jobs/JobDetail";
import { AddCandidate } from "./component/Institution/AddCandidate";
import { Add } from "./component/Drives/Add";
import { PrivatePolicy } from "./component/Pages/PrivacyPolicy";
import { TermsAndCondition } from "./component/Pages/TermsandCondition";
import { DriveList } from "./component/Drives/List";

import { AppliedDriveList } from "./component/Candidate/AppliedDriveList";
import { SelectedDriveList } from "./component/Candidate/SelectedDriveList";

import { DriveDetails } from "./component/Drives/DriveDetails";
import Profile from "./component/Candidate/Profile";
import { SelectedCandidateList } from "./component/Candidate/SelectedCandidateList";
import { SelectedCandidateDriveList } from "./component/Candidate/SelectedCandidateDriveList";
import { CaandidateList } from "./component/Candidate/CaandidateList";
import { SelectedCandidateDetails } from "./component/Candidate/SelectedCandidateDetails";
import AppliedCandidateList from "./component/Candidate/AppliedCandidateList";
import AllSelectCandidateList from "./component/Candidate/AllSelectCandidateList";
import AllCandidateList from "./component/Candidate/AllCandidateList";
import HomePageLayout from '../src/page/HomePage/HomePageLayout';

import { EmployerProfile } from "./component/Employer/Profile";
import { InstitutionProfile } from "./component/Institution/Profile";
import { UniversityProfile } from "./component/University/Profile";
import { RecruiterProfile } from "./component/Recruiter/Profile";

import ListEnquiry from "./component/Enquiry/ListEnquiry";
import ChangePassword from "./component/profile-forms/ChangePassword";
import ForgetPassword from "./component/Auth/ForgetPassword";
import GeneratePassword from "./component/Auth/GeneratePassword";
import SupportRozgar from "./component/Pages/SupportRozgar";
import AdminAllCandidateList from "./component/Candidate/AdminAllCandidates";
import { CandidateAppliedDetails } from "./component/Candidate/CandidateAppliedDetail";
import MasterSkillsList from "./component/Master/Skills/List";
import MasterSectorsList from "./component/Master/Sectors/List";
import MasterCitiesList from "./component/Master/Cities/List";
import MasterCoursesList from "./component/Master/Courses/List";
import MasterStatesList from "./component/Master/States/List";

import Notification from "./component/Common/Notification";
import Addsector from "./component/Master/Sectors/Addsector";
import Addskill from "./component/Master/Skills/Addskill";
import Addstate from "./component/Master/States/Addstate";
import Addcourse from "./component/Master/Courses/Addcourse";
import AboutUs from "./component/AboutUs/AboutUs";
import ContactUs from "./component/ContactUs/ContactUs";

const AdminRoute = (props) => { };

const PrivateRoute = (props) => { };

const Router = (props) => {
  const history = useHistory();
  const status = localStorage.getItem("status")
    ? localStorage.getItem("status")
    : false;

  const [token, setToken] = useState(status);

  const user = useSelector(selectuser);
  // useEffect(() => {
  //     alert(status);
  //     setToken(status);

  // }, [])

  return (
    <React.Fragment>
      <div id={token ? "layoutSidenav" : ""}>
        {token && <LeftSidebar />}

        <div id={token ? "layoutSidenav_content" : ""}>
          <div id={token ? "layoutSidenav_content" : ""}>
            <main>
              <div className={token ? "container-fluid" : ""}>
                {token && <TopBar />}
                <Switch>
                  {/* auth routes */}
                  <Route exact={true} path="/">
                    <Unprotected Cmp={HomePageLayout} />
                  </Route>

                  <Route exact={true} path="/login">
                    <Unprotected Cmp={Login} />
                  </Route>

                  <Route exact={true} path="/university_Register">
                    <Unprotected Cmp={RegisterUniversity} />
                  </Route>

                  <Route exact={true} path="/forgetpassword">
                    <Unprotected Cmp={ForgetPassword} />
                  </Route>

                  <Route exact={true} path="/generatepassword">
                    <Unprotected Cmp={GeneratePassword} />
                  </Route>

                  <Route exact={true} path="/PrivacyPolicy">
                    <PrivatePolicy />
                  </Route>

                  <Route exact={true} path="/AboutUs">
                    <AboutUs />
                  </Route>

                  <Route exact={true} path="/ContactUs">
                    <ContactUs />
                  </Route>

                  <Route exact={true} path="/TermsandConditions">
                    <TermsAndCondition />
                  </Route>
                  {/* <Route exact={true} path="/profile">
                    <Profile />
                  </Route> */}
                  <Route exact={true} path="/signup">
                    <Unprotected Cmp={Signup} />
                  </Route>
                  <Route exact={true} path="/dashboard">
                    <Protected
                      Cmp={Maindashboard}
                      param="dashboard"
                      path="/dashboard"
                    />
                  </Route>
                  <Route exact={true} path="/profile">
                    <Protected
                      Cmp={Profile}
                      param="profile"
                      path="/profile"
                    />
                  </Route>
                  <Route exact={true} path="/profile/:id">
                    <Protected
                      Cmp={Profile}
                      param="profile"
                      path="/profile/:id"
                    />
                  </Route>
                  <Route exact={true} path="/addCandidate">
                    <Protected
                      Cmp={AddCandidate}
                      param="addCandidate"
                      path="/addCandidate"
                    />
                  </Route>
                  <Route exact={true} path="/selectedcandidate">
                    <Protected
                      Cmp={SelectedCandidateList}
                      param="selectedcandidate"
                      path="/selectedcandidate"
                    />
                  </Route>
                  <Route exact={true} path="/universitylist">
                    <Protected
                      Cmp={UniversityList}
                      param="universitylist"
                      path="/universitylist"
                    />
                  </Route>

                  <Route exact={true} path="/universityadd">
                    <Protected
                      Cmp={UniversityAdd}
                      param="universityadd"
                      path="/universityadd"
                    />
                  </Route>

                  <Route exact={true} path="/universityedit/:id">
                    <Protected
                      Cmp={UniversityAdd}
                      param="universityedit"
                      path="/universityedit/:id"
                    />
                  </Route>

                  <Route exact={true} path="/institutionlist">
                    <Protected
                      Cmp={InstitutionList}
                      param="institutionlist"
                      path="/institutionlist"
                    />
                  </Route>

                  <Route exact={true} path="/institutionadd">
                    <Protected
                      Cmp={InstitutionAdd}
                      param="institutionadd"
                      path="/institutionadd"
                    />
                  </Route>

                  <Route exact={true} path="/institutionadd/:id">
                    <Protected
                      Cmp={InstitutionAdd}
                      param="institutionadd"
                      path="/institutionadd/:id"
                    />
                  </Route>

                  <Route exact={true} path="/employerlist">
                    <Protected
                      Cmp={EmployerList}
                      param="employerlist"
                      path="/employerlist"
                    />
                  </Route>

                  <Route exact={true} path="/employeradd">
                    <Protected
                      Cmp={EmployerAdd}
                      param="employeradd"
                      path="/employeradd"
                    />
                  </Route>

                  <Route exact={true} path="/employeradd/:id">
                    <Protected
                      Cmp={EmployerAdd}
                      param="employeradd"
                      path="/employeradd/:id"
                    />
                  </Route>

                  <Route exact={true} path="/recruiterlist">
                    <Protected
                      Cmp={RecruiterList}
                      param="recruiterlist"
                      path="/recruiterlist"
                    />
                  </Route>

                  <Route exact={true} path="/recruiteradd">
                    <Protected
                      Cmp={RecruiterAdd}
                      param="recruiteradd"
                      path="/recruiteradd"
                    />
                  </Route>

                  <Route exact={true} path="/recruiteredit/:id">
                    <Protected
                      Cmp={RecruiterAdd}
                      param="recruiteredit"
                      path="/recruiteredit/:id"
                    />
                  </Route>

                  <Route exact={true} path="/addjob">
                    <Protected Cmp={AddJob} param="addjob" path="/addjob" />
                  </Route>

                  <Route exact={true} path="/listjob">
                    <Protected Cmp={ListJob} param="listjob" path="/listjob" />
                  </Route>

                  <Route exact={true} path="/modalpopup">
                    <Protected
                      Cmp={ModalPopup}
                      param="modalpopup"
                      path="/modalpopup"
                    />
                  </Route>

                  <Route exact={true} path="/linkinguniversity/:id">
                    <Protected
                      Cmp={LinkingUniversity}
                      param="linkinguniversity"
                      path="/linkinguniversity/:id"
                    />
                  </Route>
                  <Route exact={true} path="/DriveSelectedCandidate/:id">
                    <Protected
                      Cmp={SelectedCandidateDriveList}
                      param="DriveSelectedCandidate"
                      path="/DriveSelectedCandidate/:id"
                    />
                  </Route>
                  <Route exact={true} path="/recruiterlinkinguniversity/:id">
                    <Protected
                      Cmp={RecruiterLinkingUniversity}
                      param="recruiterlinkinguniversity"
                      path="/recruiterlinkinguniversity/:id"
                    />
                  </Route>

                  <Route exact={true} path="/jobdetail/:jobid">
                    <Protected
                      Cmp={JobDetail}
                      param="jobdetail"
                      path="/jobdetail/:jobid"
                    />
                  </Route>
                  <Route exact={true} path="/addDrive">
                    <Protected Cmp={Add} param="addDrive" path="/addDrive" />
                  </Route>
                  <Route exact={true} path="/candidateslist">
                    <Protected
                      Cmp={AdminAllCandidateList}
                      param="candidateslist"
                      path="/candidateslist"
                    />
                  </Route>
                  <Route exact={true} path="/drivelist">
                    <Protected
                      Cmp={DriveList}
                      param="drivelist"
                      path="/drivelist"
                    />
                  </Route>

                  <Route exact={true} path="/applieddrivelist">
                    <Protected
                      Cmp={AppliedDriveList}
                      param="applieddrivelist"
                      path="/applieddrivelist"
                    />
                  </Route>

                  <Route exact={true} path="/appliedcandidatelist">
                    <Protected
                      Cmp={AppliedCandidateList}
                      param="appliedcandidatelist"
                      path="/appliedcandidatelist"
                    />
                  </Route>

                  <Route exact={true} path="/allselectcandidatelist">
                    <Protected
                      Cmp={AllSelectCandidateList}
                      param="allselectcandidatelist"
                      path="/allselectcandidatelist"
                    />
                  </Route>

                  <Route exact={true} path="/allcandidatelist">
                    <Protected
                      Cmp={AllCandidateList}
                      param="allcandidatelist"
                      path="/allcandidatelist"
                    />
                  </Route>

                  <Route exact={true} path="/selecteddrivelist">
                    <Protected
                      Cmp={SelectedDriveList}
                      param="selecteddrivelist"
                      path="/selecteddrivelist"
                    />
                  </Route>

                  <Route exact={true} path="/drivedetail/:driveid">
                    <Protected
                      Cmp={DriveDetails}
                      param="drivedetail"
                      path="/drivedetail/:driveid"
                    />
                  </Route>
                  <Route
                    exact={true}
                    path="/candidatedetail/:drive_id/:candidate_id/:job_id"
                  >
                    <Protected
                      Cmp={SelectedCandidateDetails}
                      param="candidatedetail"
                      path="/candidatedetail/:drive_id/:candidate_id/:job_id"
                    />
                  </Route>
                  <Route
                    exact={true}
                    path="/candidateapplieddetail/:drive_id/:candidate_id/:job_id"
                  >
                    <Protected
                      Cmp={CandidateAppliedDetails}
                      param="candidateapplieddetail"
                      path="/candidateapplieddetail/:drive_id/:candidate_id/:job_id"
                    />
                  </Route>

                  <Route exact={true} path="/employerprofile">
                    <Protected
                      Cmp={EmployerProfile}
                      param="employerprofile"
                      path="/employerprofile"
                    />
                  </Route>

                  <Route exact={true} path="/employerprofile/:id">
                    <Protected
                      Cmp={EmployerProfile}
                      param="employerprofile"
                      path="/employerprofile/:id"
                    />
                  </Route>

                  <Route exact={true} path="/institutionprofile">
                    <Protected
                      Cmp={InstitutionProfile}
                      param="institutionprofile"
                      path="/institutionprofile"
                    />
                  </Route>

                  <Route exact={true} path="/institutionprofile/:id">
                    <Protected
                      Cmp={InstitutionProfile}
                      param="institutionprofile"
                      path="/institutionprofile/:id"
                    />
                  </Route>
                  <Route exact={true} path="/universityprofile">
                    <Protected
                      Cmp={UniversityProfile}
                      param="universityprofile"
                      path="/universityprofile"
                    />
                  </Route>

                  <Route exact={true} path="/universityprofile/:id">
                    <Protected
                      Cmp={UniversityProfile}
                      param="universityprofile"
                      path="/universityprofile/:id"
                    />
                  </Route>

                  <Route exact={true} path="/recruiterprofile">
                    <Protected
                      Cmp={RecruiterProfile}
                      param="recruiterprofile"
                      path="/recruiterprofile"
                    />
                  </Route>

                  <Route exact={true} path="/recruiterprofile/:id">
                    <Protected
                      Cmp={RecruiterProfile}
                      param="recruiterprofile"
                      path="/recruiterprofile/:id"
                    />
                  </Route>

                  <Route exact={true} path="/changepassword">
                    <Protected
                      Cmp={ChangePassword}
                      param="changepassword"
                      path="/changepassword"
                    />
                  </Route>

                  <Route exact={true} path="/listenquiry">
                    <Protected
                      Cmp={ListEnquiry}
                      param="listenquiry"
                      path="/listenquiry"
                    />
                  </Route>

                  <Route exact={true} path="/support">
                    <Protected
                      Cmp={SupportRozgar}
                      param="support"
                      path="/support"
                    />
                  </Route>
                  {/**MAster */}

                  <Route exact={true} path="/masterskillslist">
                    <Protected
                      Cmp={MasterSkillsList}
                      param="masterskillslist"
                      path="/masterskillslist"
                    />
                  </Route>

                  <Route exact={true} path="/masteraddskill">
                    <Protected
                      Cmp={Addskill}
                      param="masteraddskill"
                      path="/masteraddskill"
                    />
                  </Route>

                  <Route exact={true} path="/masteraddskill/:id">
                    <Protected
                      Cmp={Addskill}
                      param="masteraddskill"
                      path="/masteraddskill/:id"
                    />
                  </Route>

                  <Route exact={true} path="/mastersectorslist">
                    <Protected
                      Cmp={MasterSectorsList}
                      param="mastersectorslist"
                      path="/mastersectorslist"
                    />
                  </Route>

                  <Route exact={true} path="/mastersectoradd">
                    <Protected
                      Cmp={Addsector}
                      param="mastersectoradd"
                      path="/mastersectoradd"
                    />
                  </Route>

                  <Route exact={true} path="/mastersectoradd/:id">
                    <Protected
                      Cmp={Addsector}
                      param="mastersectoradd"
                      path="/mastersectoradd/:id"
                    />
                  </Route>

                  <Route exact={true} path="/mastercourseslist">
                    <Protected
                      Cmp={MasterCoursesList}
                      param="mastercourseslist"
                      path="/mastercourseslist"
                    />
                  </Route>

                  <Route exact={true} path="/mastercoursesadd">
                    <Protected
                      Cmp={Addcourse}
                      param="mastercoursesadd"
                      path="/mastercoursesadd"
                    />
                  </Route>

                  <Route exact={true} path="/mastercoursesadd/:id">
                    <Protected
                      Cmp={Addcourse}
                      param="mastercoursesadd"
                      path="/mastercoursesadd/:id"
                    />
                  </Route>

                  <Route exact={true} path="/masterstateslist">
                    <Protected
                      Cmp={MasterStatesList}
                      param="masterstateslist"
                      path="/masterstateslist"
                    />
                  </Route>

                  <Route exact={true} path="/masterstateadd">
                    <Protected
                      Cmp={Addstate}
                      param="masterstateadd"
                      path="/masterstateadd"
                    />
                  </Route>

                  <Route exact={true} path="/masterstateadd/:id">
                    <Protected
                      Cmp={Addstate}
                      param="masterstateadd"
                      path="/masterstateadd/:id"
                    />
                  </Route>

                  <Route exact={true} path="/mastercitieslist">
                    <Protected
                      Cmp={MasterCitiesList}
                      param="mastercitieslist"
                      path="/mastercitieslist"
                    />
                  </Route>

                  <Route exact={true} path="/notification">
                    <Protected
                      Cmp={Notification}
                      param="notification"
                      path="/notification"
                    />
                  </Route>


                  <Route path="*" component={Page404} />

                  {/* auth routes */}
                </Switch>
              </div>
            </main>
          </div>
          {token && <Footer />}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Router;
